export default __webpack_public_path__ + "static/media/5-Generations.202d3117.svg";